import React, { useEffect } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import get from 'lodash/get';

// GLOBAL FUNCTIONS
import { controlName } from 'functions.js';

// LOCAL COMPONENTS
import Attachment from 'routers/interface/tools/attachment/Attachment';

// STYLES
import styles from './epostAttachment.module.scss';

// MAIN COMPONENT
const EpostAttachment = ({
  name,
  label,
  ...props
}) => {

  // FORMIK
  const { values, setFieldValue } = useFormikContext() || {};

  // EFFECTS
  useEffect(
    () => {
      const aryAttachments = values.aryAttachments || [];
      const { temp_attachment_id } = get(values, controlName(name, 'dummy')) || {};
      if (temp_attachment_id && !aryAttachments?.includes(temp_attachment_id)) setFieldValue('aryAttachments', [...aryAttachments, temp_attachment_id]);
    },
    [name, values, setFieldValue]
  )

  // RENDER
  return (
    <Attachment.Upload
      {...props}
      name={controlName(name, 'dummy')}
      label={{
        className: styles.label,
        children: label
      }}
      uploadType='sales'
      useTemp
      useDocUpr={false}
      multiple={false}
      required
    />
  )
}

export default EpostAttachment;
